function setDocumentTitle(newTitle) {
    document.title = newTitle
}

export default {
    setDocumentTitle: setDocumentTitle,
};
